<template>
    <div>
        <Fieldset :legend="$t('searchHeader')" :toggleable="true">
            <div class="p-fluid p-mt-2 p-ml-3 p-mr-3 p-mb-2" @keyup.enter="saveData_Modal('search')">
                <div class="p-formgrid p-grid p-col">
                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="incident_name">{{ $t('ii_incident_name') }}</label>
                        <InputText
                            id="incident_name"
                            type="text"
                            v-model="incident_name"
                            ref="TextBox_1_search"
                            @keyup.left="moveFocus($event, 'TextBox_3_search', 'Button')"
                            @keyup.right="moveFocus($event, 'TextBox_2_search', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="disaster">{{ $t('disaster_type') }}</label>
                        <Dropdown
                            v-model="disasterTypeSelect"
                            :options="disasterTypeOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="disasterTypeOptions">
                                <div v-if="disasterTypeOptions.value">
                                    <div>{{ disasterTypeOptions.value.system_name }}</div>
                                </div>
                                <span v-else>
                                    {{ disasterTypeOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="disasterTypeOptions">
                                <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col-12 p-lg-3 p-mt-2">
                        <label for="disaster_detail">{{ $t('disaster_detail') }}</label>
                        <Dropdown
                            :disabled="disabledDetail == 1"
                            v-model="disasterDetailSelect"
                            :options="disasterDetailOptions"
                            optionLabel="system_name"
                            :filter="true"
                            :placeholder="$t('placeholderSelectBox')"
                            :showClear="true"
                            :clearFilterDropdown="dropdownClearFilerValue"
                        >
                            <template #value="disasterDetailOptions">
                                <div v-if="disasterDetailOptions.value">
                                    <div>{{ disasterDetailOptions.value.system_name }}</div>
                                </div>
                                <span v-else>
                                    {{ disasterDetailOptions.placeholder }}
                                </span>
                            </template>
                            <template #option="disasterDetailOptions">
                                <div>{{ disasterDetailOptions.option.system_name }}</div>
                            </template>
                        </Dropdown>
                    </div>

                    <div class="p-field p-col">
                        <div class="p-formgrid p-grid p-jc-end p-mt-5">
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                v-if="window.width <= 430"
                                @click="MobileClearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            />
                            <Button
                                v-else
                                @click="clearSearchField()"
                                :label="$t('clearBtn')"
                                class="p-button-clear p-ml-3 p-mr-3"
                                ref="TextBox_2_search"
                                @keyup.left="moveFocus($event, 'TextBox_1_search', 'Input')"
                                @keyup.right="moveFocus($event, 'TextBox_3_search', 'Button')"
                            />
                            <!-- Doe โหลด โทรศัพท์ -->
                            <Button
                                @click="searchIncidentInfo()"
                                :label="$t('searchBtn')"
                                class="p-button-info"
                                ref="TextBox_3_search"
                                @keyup.left="moveFocus($event, 'TextBox_2_search', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_1_search', 'Input')"
                            />
                        </div>
                    </div>
                </div>
                <div class="p-formgrid p-grid p-col p-mt-1">
                    <text-footer :data="Data_text_Footer" :checkShow="text_Footer" :countItem="incident_Table.length.toLocaleString('en-US')" />
                </div>
            </div>
        </Fieldset>

        <div class="card p-fluid p-mt-2">
            <!-- Doe : เพิ่ม ลำดับ 1/4   sortField="index" :sortOrder="1" -->
            <DataTable
                :value="columns_disabled ? incident_Table : []"
                :paginator="true"
                scrollHeight="500px"
                :rows="10"
                dataKey="incident_id"
                :sortOrder="1"
                sortField="index"
                ref="dt"
                :exportFilename="`ข้อมูลเผชิญเหตุ-${date}`"
                :rowHover="true"
                :selection.sync="selectedIncidentInfo"
                :filters="filters"
                :loading="loading"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[10, 20, 50]"
                currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
            >
                <!-- Doe : เพิ่ม ลำดับ 1/4 จบ  sortField="index" :sortOrder="1" -->
                <template #header>
                    <div class="p-grid">
                        <div class="table-header p-col-12 p-lg-1" style="padding: 7px" id="Create" v-if="checkAdd_data != 'false'">
                            <Button @click="incidentModal = true" :label="$t('addBtn')" class="p-button-success" />
                        </div>

                        <!-- Doe : PDF 1/3 -->
                        <div class="table-header" style="padding: 7px" id="EX">
                            <Button @click="exportCSV()" :label="$t('exportBtn')" style="background-color: green" />
                        </div>
                        <div class="table-header" style="padding: 7px" id="PDF">
                            <SplitButton
                                label="ส่งออก PDF"
                                :model="items"
                                class="p-button-raised p-button-danger"
                                style="background-color: #f33737"
                            ></SplitButton>
                        </div>
                        <!-- Doe : PDF 1/3 จบ -->

                        <!-- Doe PDF เลือกได้  1/5   -->
                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px">
                            <Button
                                @click="EditPDF()"
                                icon="pi pi-cog"
                                :label="'ตั้งค่า'"
                                style="background-color: #0288d1; border: 1px solid #0288d1"
                            />
                        </div>

                        <div class="table-header" id="TABLE_EDIT" style="padding: 7px" v-if="selectedIncidentInfo && selectedIncidentInfo.length > 0">
                            <Button
                                @click="updateDates()"
                                icon="pi pi-cog"
                                :label="'ปรับปรุงข้อมูล'"
                                style="background-color: #fab12f; border: 1px solid #fab12f"
                            />
                        </div>

                        <!-- Doe PDF เลือกได้  1/5 จบ  -->

                        <div class="table-header p-col-12 p-lg-3" id="Search" style="margin-left: auto">
                            <!-- <span class="p-input-icon-left">
                <i class="pi pi-search" /><InputText
                  v-model="filters['global']"
                  :placeholder="$t('searchHeader')"
                />
              </span> -->

                            <!-- Doe ค้นหา  1/5 -->

                            <span class="p-input-icon-left" v-if="columns_disabled">
                                <i class="pi pi-search" />
                                <InputText v-model="filter" @input="search" :placeholder="$t('searchHeader')" ref="searchInput" />
                            </span>
                            <span class="p-input-icon-left" v-else>
                                <i class="pi pi-search" />
                                <InputText disabled v-model="filter" :placeholder="$t('searchHeader')" />
                            </span>
                            <!-- Doe ค้นหา  1/5 จบ-->
                        </div>
                    </div>
                </template>

                <Column :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                    <template #header>
                        <div v-if="columns_disabled">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedIncidentInfo.length === incident_Table.length"
                                @change="onSelectAll($event.target.checked)"
                            />
                        </div>
                    </template>
                    <template #body="slotProps">
                        <div class="table_row" v-if="columns_disabled" style="text-align: center">
                            <input
                                style="width: 20px; height: 20px"
                                type="checkbox"
                                :checked="selectedIncidentInfo.some((item) => item.incident_id === slotProps.data.incident_id)"
                                @change="onSelectRow(slotProps.data, $event.target.checked)"
                            />
                        </div>
                    </template>
                </Column>

                <template #empty>{{ $t('TableEmpty') }}</template>
                <div v-if="columns_index == true">
                    <!--Doe : เพิ่มลำดับ 2/4-->
                    <Column field="index" :header="'ลำดับ'" :sortable="true" :headerStyle="tableColSticky('8rem', 'center', 'sticky', 'top')">
                        <template #body="dataTable">
                            <div class="table_row" v-if="columns_index == true">
                                {{ dataTable.data.index }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>
                <!--Doe : เพิ่มลำดับ 2/4 จบ-->

                <div v-if="columns_incident_name == true">
                    <Column
                        field="incident_name"
                        :header="$t('ii_incident_name')"
                        :sortable="true"
                        :headerStyle="tableColSticky('25rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_incident_name == true">
                                {{ dataTable.data.incident_name }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_disaster_name == true">
                    <Column
                        field="disaster_name"
                        :header="$t('disaster_type')"
                        :sortable="true"
                        :headerStyle="tableColSticky('25rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_disaster_name == true">
                                <div v-if="dataTable.data.disaster_name == null">-</div>
                                <div v-else>{{ dataTable.data.disaster_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_detail_name == true">
                    <Column
                        field="detail_name"
                        :header="$t('disaster_detail')"
                        :sortable="true"
                        :headerStyle="tableColSticky('25rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_detail_name == true">
                                <div v-if="dataTable.data.detail_name == null">-</div>
                                <div v-else>{{ dataTable.data.detail_name }}</div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_create == true">
                    <Column
                        field="date_create_ddmmyy"
                        :header="'วันที่สร้างข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_create == true">
                                {{ dataTable.data.date_create_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div v-if="columns_date_update == true">
                    <Column
                        field="date_update_ddmmyy"
                        :header="'วันที่ปรับปรุงข้อมูล'"
                        :sortable="true"
                        :headerStyle="tableColSticky('15rem', '', 'sticky', 'top')"
                    >
                        <template #body="dataTable">
                            <div v-if="columns_date_update == true">
                                {{ dataTable.data.date_update_ddmmyy }}
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column :headerStyle="tableColNone()"></Column>
                </div>

                <div
                    v-if="
                        columns_detail_name ||
                        columns_index ||
                        columns_incident_name ||
                        columns_disaster_name ||
                        columns_date_create ||
                        columns_date_update
                    "
                >
                    <Column
                        :header="$t('controlTable')"
                        :headerStyle="table_headerStyle"
                        :bodyStyle="table_bodyStyle"
                        v-if="checkEdit_data != 'false' || checkDelete_data != 'false'"
                    >
                        <template #body="dataTable">
                            <div class="p-formgrid col_manege" v-if="checkNotAdminPermission(dataTable.data.user_organize)">
                                <div :class="table_BOXmanege" v-if="checkEdit_data != 'false'">
                                    <Button
                                        @click="
                                            incidentModal = true;
                                            editData(dataTable.data.incident_id);
                                            temp = dataTable.data.incident_id;
                                        "
                                        icon="pi pi-pencil"
                                        :label="table_editBTN"
                                        class="p-button-rounded p-button-warning"
                                    />
                                </div>
                                <div :class="table_BOXmanege" v-if="checkDelete_data != 'false'">
                                    <Button
                                        @click="
                                            // displayConfirmation = true;
                                            temp = dataTable.data.incident_id;
                                            deleteAt = '';
                                            alertDisplay(temp, deleteAt);
                                        "
                                        icon="pi pi-trash"
                                        :label="table_deleteBTN"
                                        class="p-button-rounded p-button-danger"
                                    />
                                </div>
                            </div>
                        </template>
                    </Column>
                </div>
                <div v-else>
                    <Column headerStyle="width: 0"></Column>
                </div>
            </DataTable>
        </div>
        <!-- v-if="loadingCreate" -->
        <!-- Manage data -->
        <Dialog
            :modal="true"
            :visible.sync="incidentModal"
            :style="{ width: '80%' }"
            :contentStyle="{ 'overflow-y': 'scroll' }"
            :closable="loadingCreate ? false : true"
            :header="header"
        >
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_Main')">
                <!-- โหลดเพิ่มแก้ไข 1/8-->
                <div class="From_Loading" style="top: 38%" v-if="loadingCreate">
                    <ProgressSpinner style="width: 120px; height: 120px; color: red" strokeWidth="5" animationDuration="1s" />
                    <div class="waveTextAnimated">
                        <span>กำ</span>
                        <span>ลัง</span>
                        <span>บัน</span>
                        <span>ทึก</span>
                        <span>ข้อ</span>
                        <span>มูล</span>
                        <!-- กำลังบันทึกข้อมูล -->
                    </div>
                </div>
                <!-- โหลดเพิ่มแก้ไข 1/8 จบ-->
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-9" style="margin-top: -5px">
                            <label for="ii_incident_name">{{ $t('ii_incident_name') }} <span class="required-input">*</span></label>
                            <InputText
                                id="ii_incident_name"
                                type="text"
                                v-model="ii_incident_name"
                                autofocus
                                required="true"
                                :class="{
                                    'p-invalid': error_ii_incident_name && !ii_incident_name
                                }"
                                ref="TextBox_1"
                                @keyup.left="moveFocus($event, 'TextBox_1', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_2', 'Button')"
                            />
                            <small class="p-invalid" v-if="error_ii_incident_name && !ii_incident_name">{{ $t('ii_incident_name_validate') }}</small>
                        </div>

                        <div class="p-field p-col-12 p-lg-3">
                            <label for="ii_severity_level">{{ $t('ii_severity_level') }}</label>
                            <!-- <InputNumber v-model="ii_severity_level" id="ii_severity_level" /> -->
                            <Dropdown
                                v-model="ii_severity_level"
                                :options="ii_severity_level_Option"
                                optionLabel=""
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="ii_severity_level_Option">
                                    <div v-if="ii_severity_level_Option.value">
                                        <div>{{ ii_severity_level_Option.value }}</div>
                                    </div>
                                </template>
                                <template #option="ii_severity_level_Option">
                                    <div>{{ ii_severity_level_Option.option }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>
                    <div class="p-grid p-col-12">
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="disaster">{{ $t('disaster_type') }} <span class="required-input"> </span></label>
                            <Dropdown
                                v-model="ii_disaster_type"
                                @change="someHandler"
                                :options="disasterTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterTypeOptions">
                                    <div v-if="disasterTypeOptions.value">
                                        <div>{{ disasterTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterTypeOptions">
                                    <div class="EV_disasterOptions">{{ disasterTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-4">
                            <label for="disaster_detail">{{ $t('disaster_detail') }} <span class="required-input"> </span></label>
                            <Dropdown
                                :disabled="ii_disabledDetail == 1"
                                v-model="ii_disaster_detail"
                                :options="disasterDetailOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="disasterDetailOptions">
                                    <div v-if="disasterDetailOptions.value">
                                        <div>{{ disasterDetailOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ disasterDetailOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="disasterDetailOptions">
                                    <div>{{ disasterDetailOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>

                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_create_form">วันที่สร้างข้อมูล <span class="required-input"> </span></label>
                            <InputText id="date_create_form" type="text" v-model="date_create_form" autofocus disabled />
                        </div>
                        <div class="p-field p-col-12 p-lg-2">
                            <label for="date_update_form">{{ $t('imp_update_info_date') }}<span class="required-input"> </span></label>
                            <InputText id="date_update_form" type="text" v-model="date_update_form" autofocus disabled />
                        </div>
                    </div>

                    <div class="p-field p-col-6 p-lg-3">
                        <Button
                            @click="deviceDetailModal = true"
                            icon="pi pi-plus"
                            :label="$t('addBtn')"
                            class="p-button-success"
                            ref="TextBox_2"
                            @keyup.left="moveFocus($event, 'TextBox_1', 'input')"
                            @keyup.right="moveFocus($event, 'TextBox_3', 'Button')"
                            @keyup.up="moveFocus($event, 'TextBox_1', 'Input')"
                            @keyup.down="moveFocus($event, 'TextBox_3', 'Button')"
                        />
                    </div>

                    <div class="p-field p-col-12 p-lg-12">
                        <DataTable
                            :value="deviceDetail_table"
                            :scrollable="true"
                            scrollHeight="500px"
                            :paginator="true"
                            :rows="5"
                            :rowHover="true"
                            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                            :rowsPerPageOptions="[5, 10, 20, 50]"
                            currentPageReportTemplate="แสดงผล {first} ถึง {last} จากทั้งหมด {totalRecords}"
                        >
                            <template #empty>{{ $t('TableEmpty') }}</template>
                            <Column field="device_type" :header="$t('ii_device_type')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    {{ dataTable.data.device_type }}
                                </template>
                            </Column>
                            <Column field="amount" :header="$t('ide_amount')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    <div v-if="dataTable.data.amount != null">
                                        {{ dataTable.data.amount }}
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </Column>
                            <Column field="unit" :header="$t('ide_unit_name')" :sortable="true" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    <div v-if="dataTable.data.unit != null">
                                        {{ dataTable.data.unit.system_name }}
                                    </div>
                                    <div v-else>-</div>
                                </template>
                            </Column>
                            <Column :header="$t('controlTable')" headerStyle="width: 15rem">
                                <template #body="dataTable">
                                    <div class="p-formgrid p-grid">
                                        <div class="p-field p-col">
                                            <Button
                                                @click="
                                                    // displayConfirmation = true;
                                                    deviceDetailDelete = dataTable.data;
                                                    deleteAt = 'detail-table';
                                                    alertDisplay(deviceDetailDelete, deleteAt);
                                                "
                                                icon="pi pi-trash"
                                                :label="$t('deleteBtn')"
                                                class="p-button-rounded p-button-danger"
                                            />
                                        </div>
                                    </div>
                                </template>
                            </Column>
                        </DataTable>
                    </div>
                </div>
            </div>
            <template #footer>
                <!-- โหลดเพิ่มแก้ไข 2/8-->
                <Button
                    v-if="selectedData != ''"
                    :label="$t('cancelBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_3"
                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                />
                <Button
                    v-else
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="clearData()"
                    ref="TextBox_3"
                    @keyup.left="moveFocus($event, 'TextBox_2', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_4', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    :disabled="loadingCreate ? true : false"
                    class="p-button-text"
                    @click="saveData()"
                    ref="TextBox_4"
                    @keyup.left="moveFocus($event, 'TextBox_3', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1', 'Input')"
                    @keyup.up="moveFocus($event, 'TextBox_2', 'Button')"
                />
                <!-- โหลดเพิ่มแก้ไข 2/8 จบ-->
            </template>
        </Dialog>

        <!-- Manage device detail data -->
        <Dialog :modal="true" :visible.sync="deviceDetailModal" :style="{ width: '700px' }" :header="headerDetail">
            <div class="confirmation-content" @keyup.enter="saveData_Modal('Modal_device')">
                <label>{{ $t('ide_modal_subtitle') }}</label>
                <div class="p-fluid p-mt-3">
                    <div class="p-formgrid p-grid p-col-12 p-lg-12">
                        <div class="p-field p-col-12 p-lg-4" style="margin-top: -5px">
                            <label for="device_type">{{ $t('ii_device_type') }} <span class="required-input">*</span></label>
                            <Dropdown
                                v-model="ii_device_type"
                                :options="deviceTypeOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :class="{
                                    'p-invalid': error_ii_device_type && !ii_device_type
                                }"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="deviceTypeOptions">
                                    <div v-if="deviceTypeOptions.value">
                                        <div>{{ deviceTypeOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ deviceTypeOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="deviceTypeOptions">
                                    <div>{{ deviceTypeOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                            <small class="p-invalid" v-if="error_ii_device_type && !ii_device_type">{{ $t('ii_device_type_validate') }}</small>
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ii_device_amount">{{ $t('ide_amount') }}</label>
                            <InputNumber
                                v-model="ii_device_amount"
                                id="ii_device_amount"
                                showButtons
                                :min="0"
                                ref="TextBox_1_device"
                                @keyup.left="moveFocus($event, 'TextBox_3_device', 'Button')"
                                @keyup.right="moveFocus($event, 'TextBox_2_device', 'Button')"
                                @keyup.down="moveFocus($event, 'TextBox_2_device', 'Button')"
                            />
                        </div>
                        <div class="p-field p-col-12 p-lg-4">
                            <label for="ii_device_unit">{{ $t('ide_unit_name') }}</label>
                            <Dropdown
                                :disabled="ii_disabledUnit == 1"
                                v-model="ii_device_unit"
                                :options="unitNameOptions"
                                optionLabel="system_name"
                                :filter="true"
                                :placeholder="$t('placeholderSelectBox')"
                                :showClear="true"
                                :clearFilterDropdown="dropdownClearFilerValue"
                            >
                                <template #value="unitNameOptions">
                                    <div v-if="unitNameOptions.value">
                                        <div>{{ unitNameOptions.value.system_name }}</div>
                                    </div>
                                    <span v-else>
                                        {{ unitNameOptions.placeholder }}
                                    </span>
                                </template>
                                <template #option="unitNameOptions">
                                    <div>{{ unitNameOptions.option.system_name }}</div>
                                </template>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button
                    :label="$t('clearBtn')"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="setDefaultDetail()"
                    ref="TextBox_2_device"
                    @keyup.left="moveFocus($event, 'TextBox_1_device', 'InputNumber')"
                    @keyup.right="moveFocus($event, 'TextBox_3_device', 'Button')"
                    @keyup.up="moveFocus($event, 'TextBox_1_device', 'InputNumber')"
                />
                <Button
                    :label="$t('saveBtn')"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="addDeviceData()"
                    ref="TextBox_3_device"
                    @keyup.left="moveFocus($event, 'TextBox_2_device', 'Button')"
                    @keyup.right="moveFocus($event, 'TextBox_1_device', 'InputNumber')"
                    @keyup.up="moveFocus($event, 'TextBox_1_device', 'InputNumber')"
                />
            </template>
        </Dialog>

        <Dialog :modal="true" :header="$t('ConfirmDelete')" :visible.sync="displayConfirmation" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <i class="pi pi-exclamation-triangle p-mr-3 p-mt2" style="font-size: 2rem" />
                <span>{{ $t('ConfirmDeleteSub') }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="confirmDelete()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Are you sure for close this modal -->
        <Dialog :modal="true" :header="$t('ConfirmCloseModal')" :visible.sync="displayConfirmationCloseModal" :style="{ width: '350px' }">
            <div class="confirmation-content p-mt-3">
                <span>{{ "$t('confirmBtn')" }}</span>
            </div>
            <template #footer>
                <Button :label="$t('cancelBtn')" icon="pi pi-times" @click="displayConfirmationCloseModal = false" class="p-button-text" />
                <Button :label="$t('confirmBtn')" icon="pi pi-check" @click="closeAllModal()" class="p-button-text" autofocus />
            </template>
        </Dialog>

        <!-- Doe PDF เลือกได้  -->
        <Dialog header="ตั้งค่า " :visible.sync="displayEditPDF" :style="{ width: '25rem' }" :contentStyle="{ 'overflow-y': 'visible' }">
            <label>ตั้งค่าการแสดงข้อมูลตารางและการส่งออกข้อมูล</label>
            <div style="margin: 2.5rem 1rem 0 1rem">
                <div class="p-formgrid p-grid">
                    <div class="p-field p-col-12">
                        <MultiSelect
                            v-model="columnsSelectorDialog"
                            :options="columns"
                            optionLabel="title"
                            :placeholder="$t('placeholderSelectBox')"
                            :filter="true"
                            class="multiselect-custom"
                            :clearFilterMultiSelect="multiSelectClearFilerValue"
                        >
                            <template #value="slotProps">
                                <div class="item item-value" v-for="option of slotProps.value" :key="option.dataKey">
                                    <div>{{ option.title }}</div>
                                </div>
                                <template v-if="!slotProps.value || slotProps.value.length === 0">
                                    {{ $t('placeholderSelectBox') }}
                                </template>
                            </template>
                            <template #option="slotProps">
                                <div class="item">
                                    <div>{{ slotProps.option.title }}</div>
                                </div>
                            </template>
                        </MultiSelect>
                        <div style="margin-top: 1rem; display: flex; justify-content: flex-end">
                            <Button
                                @click="
                                    ClearEditPDF();
                                    multiSelectClearFilerValue += 1;
                                "
                                class="p-button-clear"
                                :label="'ล้างข้อมูล'"
                                style="margin-right: 1rem"
                            />
                            <Button @click="SelectAllEditPDF()" class="p-button-info" :label="'เลือกทั้งหมด'" />
                        </div>
                    </div>
                </div>
            </div>
            <template #footer>
                <div>
                    <Button @click="CloseEditPDF()" :label="'ยกเลิก'" icon="pi pi-times" class="p-button-text" />
                    <Button @click="SaveEditPDF()" :label="'บันทึก'" icon="pi pi-check" class="p-button-text" />
                </div>
            </template>
        </Dialog>
        <!-- Doe PDF เลือกได้ -->
    </div>
</template>

<script>
// Doe : PDF 2/3
// เพิ่ม pdf กับ font
// import { jsPDF } from "jspdf";
// import {font} from '../../../../public/assets/font/Sarabun-Regular-normal';
// Doe : PDF 2/3 จบ
import moment from 'moment';

import textFooter from '../../../mixins/textFooter_Search_html';

export default {
    name: 'initial-incident',
    components: {
        textFooter
    },
    data() {
        return {
            searchTimeout: null,
            searchInputRef: null,
            temp: null,
            multiSelectClearFilerValue: 0,
            dropdownClearFilerValue: 0,
            date: moment().locale('th').add(543, 'year').format('l'),
            // Doe ค้นหา  2/5
            filter: '',
            ms: false,
            cloneTable: [],
            // Doe ค้นหา  2/5 จบ

            // Doe โหลด โทรศัพท์
            // Doe width 1/4
            window: {
                width: 0,
                height: 0
            },

            checkRole: null,
            checkView_data: null,
            checkAdd_data: null,
            checkEdit_data: null,
            checkDelete_data: null,

            incident_name: '',
            disasterTypeOptions: [],
            disasterTypeSelect: null,
            disabledDetail: 1,
            disasterDetailOptions: [],
            disasterDetailSelect: null,

            displayConfirmation: false,
            filters: {},
            selectedIncidentInfo: [],

            incident_Table: [],
            selectedData: '',
            incidentModal: false,
            deviceDetailModal: false,

            deviceDetail_table: [],
            deviceDetailDelete: {},
            deleteAt: '',
            ii_incident_name: '',
            ii_severity_level: null,
            ii_severity_level_Option: [1, 2, 3, 4, 5],
            ii_disaster_type: null,
            ii_disabledDetail: 1,
            ii_disaster_detail: null,

            deviceTypeOptions: [],
            ii_device_type: null,
            ii_device_amount: 0,
            unitNameOptions: [],
            ii_disabledUnit: 1,
            ii_device_unit: null,
            error_ii_device_type: false,
            error_ii_incident_name: false,
            header: this.$i18n.t('ii_modal_title_add'),
            headerDetail: this.$i18n.t('ii_modal_title_add_detail'),

            check_duplicate: '',
            displayConfirmationCloseModal: false,
            tempFor_displayConfirmationCloseModal: '',

            loading: false,
            // โหลดเพิ่มแก้ไข 3/8
            loadingCreate: false,
            // โหลดเพิ่มแก้ไข 3/8 จบl

            //
            text_Footer: false,
            Clone_Data_text_Footer: [],
            Data_text_Footer: [
                {
                    DataName: 'ชื่อชุดเผชิญเหตุ',
                    textShow: ''
                },
                {
                    DataName: 'ประเภทสาธารณภัย',
                    textShow: ''
                },
                {
                    DataName: 'ลักษณะที่เกิดเหตุ',
                    textShow: ''
                }
            ],

            table_BOXmanege: window.innerWidth > 700 ? 'p-field p-col' : '',
            table_editBTN: window.innerWidth > 700 ? this.$i18n.t('editBtn') : '',
            table_deleteBTN: window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '',

            table_headerStyle: this.checkInnerWidth('15rem', 'Column'),
            table_bodyStyle: this.checkInnerWidth('15rem', 'Body'),

            date_create_form: '',
            date_update_form: '',

            // Doe PDF เลือกได้  2/5
            setPDF_Hor: 'l',
            setPosition_Hor: [802, 34, 802, 570],
            setPDF_Ver: 'p',
            setPosition_Ver: [570, 34, 575, 815],
            setPDF_Styles: 'grid',
            setnamePDF: 'ตารางข้อมูลชุดเผชิญเหตุ',
            setPDF_fillColor: [95, 154, 250],
            setPDF_Margin: { left: 15, right: 15 },

            PDF_minCellWidthVer: 70,
            PDF_FontHeaderVer: 15,
            PDF_FontBodyVer: 12,

            PDF_BodySizeSelect: {},
            PDF_BodySize: {
                index: { cellWidth: 35 }
            },

            PDF_minCellWidthHor: 70,
            PDF_FontHeaderHor: 15,
            PDF_FontBodyHor: 12,

            PDF_BodySizeHorSelect: {},
            PDF_BodySizeHor: {
                index: { cellWidth: 35 }
            },
            columns: [
                { title: 'ลำดับ', dataKey: 'index' },
                { title: 'ชื่อชุดเผชิญเหตุ', dataKey: 'incident_name' },
                { title: 'ประเภทสาธารณภัย', dataKey: 'disaster_name' },
                { title: 'ลักษณะที่เกิดเหตุ', dataKey: 'detail_name' },
                { title: 'วันที่สร้างข้อมูล', dataKey: 'date_create_ddmmyy' },
                { title: 'วันที่ปรับปรุงข้อมูล', dataKey: 'date_update_ddmmyy' }
            ],

            columnsSelector: null,
            columnsSelectorDialog: null,

            displayEditPDF: false,

            columns_index: true,
            columns_incident_name: true,
            columns_disaster_name: true,
            columns_detail_name: true,

            columns_date_create: true,
            columns_date_update: true,

            columns_disabled: true,
            // Doe PDF เลือกได้  2/5  จบ

            // Doe : PDF 3/3
            items: [
                {
                    label: ' แนวตั้ง',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวตั้ง', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Ver,
                            setPosition: this.setPosition_Ver,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderVer,
                            Body_FontSize: this.PDF_FontBodyVer,
                            minCell: this.PDF_minCellWidthVer,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                },

                {
                    label: 'แนวนอน',
                    command: () => {
                        this.$toast.add({ severity: 'success', summary: 'PDF', detail: 'แนวนอน', life: 3000 });

                        let columns = this.columnsSelector;

                        const Body_setCenter = ['index'];

                        const PintPDF = {
                            streak: this.setPDF_Hor,
                            setPosition: this.setPosition_Hor,
                            PDF_Styles: this.setPDF_Styles,
                            data: this.$refs.dt.processedData,
                            columns: columns,
                            columnsStyles: this.PDF_BodySizeHorSelect,
                            FileName: this.setnamePDF,
                            checkBody_Center: true,
                            Body_Center: Body_setCenter,
                            Col_FontSize: this.PDF_FontHeaderHor,
                            Body_FontSize: this.PDF_FontBodyHor,
                            minCell: this.PDF_minCellWidthHor,
                            marginPDF: this.setPDF_Margin,
                            fillColorPDF: this.setPDF_fillColor
                        };
                        this.printPDF(PintPDF);
                    }
                }
            ]
            // Doe : PDF 3/3 จบ
        };
    },
    watch: {
        async incidentModal(val) {
            const today = new Date();
            const thaiDate = today.toLocaleDateString('th-TH', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });

            if (val == false) {
                if (this.tempFor_displayConfirmationCloseModal == '' && this.selectedData == '' && this.ii_incident_name != '') {
                    // this.displayConfirmationCloseModal = true;
                    this.$fire({
                        title: 'ยืนยันการปิดหน้าต่างจัดการข้อมูล',
                        text: 'คุณต้องการออกจากการจัดการข้อมูลใช่หรือไม่ ?',

                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'ตกลง',
                        cancelButtonText: 'ยกเลิก'
                    }).then((result) => {
                        if (result.value) {
                            this.incidentModal = false;
                            this.clearData();
                        } else {
                            this.incidentModal = true;
                        }
                    });
                } else {
                    this.clearData();
                    await this.axios
                        .post(`${this.$url_service}/initial/option`, {
                            body: { group: 'dg-02' }
                        })
                        .then((response) => {
                            (this.disasterTypeOptions = response.data.data),
                                this.disasterTypeOptions.splice(0, 0, {
                                    system_id: 'getall',
                                    system_name: this.$i18n.t('selectAll')
                                });
                        });
                }
            } else {
                if (this.temp === null) {
                    this.date_create_form = thaiDate;
                    this.date_update_form = thaiDate;
                }

                await this.axios
                    .post(`${this.$url_service}/initial/option`, {
                        body: { group: 'dg-02' }
                    })
                    .then((response) => {
                        this.disasterTypeOptions = response.data.data;
                    });
            }
        },

        async disasterTypeSelect(val) {
            if (val != null) {
                this.disabledDetail = 0;
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-detail-disaster', id: val.system_id }
                    })
                    .then((response) => {
                        (this.disasterDetailOptions = response.data.data),
                            this.disasterDetailOptions.splice(0, 0, {
                                system_id: 'getall',
                                system_name: this.$i18n.t('selectAll')
                            });
                    });
            } else {
                this.disabledDetail = 1;
                this.disasterDetailSelect = null;
            }
        },

        async ii_disaster_type(val) {
            if (val == null) {
                this.ii_disabledDetail = 1;
                this.ii_disaster_detail = null;
            } else {
                this.ii_disabledDetail = 0;
                await this.axios
                    .post(`${this.$url_service}/get/datagroup`, {
                        body: { topic: 'get-detail-disaster', id: val.system_id }
                    })
                    .then((response) => (this.disasterDetailOptions = response.data.data));
            }
        },

        async deviceDetailModal(val) {
            if (val == false) {
                this.setDefaultDetail();
            } else {
                this.FocusRef_delay('TextBox_1_device', 'InputNumber');
                await this.axios
                    .post(`${this.$url_service}/initial/equipment`, {
                        body: { topic: 'get-option-all' }
                    })
                    .then((response) => (this.deviceTypeOptions = response.data.data));
            }
        },

        async ii_device_type(val) {
            if (val != null) {
                this.ii_device_unit = null;
                this.ii_disabledUnit = 0;
                await this.axios
                    .post(`${this.$url_service}/initial/equipment`, {
                        body: { topic: 'get-option-unit', id: val.system_group_id }
                    })
                    .then((response) => (this.unitNameOptions = response.data.data));
            } else {
                this.ii_disabledUnit = 1;
                this.ii_device_unit = null;
            }
        },

        async selectedData(val) {
            if (val != '') {
                if (val.disaster_id == null && val.detail_id == null) {
                    this.ii_disaster_type = null;
                    this.ii_disaster_detail = null;
                } else if (val.disaster_id != null && val.detail_id == null) {
                    this.ii_disaster_type = {
                        system_id: val.disaster_id,
                        system_name: val.disaster_name
                    };
                    this.ii_disaster_detail = null;
                    await this.axios
                        .post(`${this.$url_service}/get/datagroup`, {
                            body: { topic: 'get-detail-disaster', id: val.disaster_id }
                        })
                        .then((response) => (this.disasterDetailOptions = response.data.data));
                } else if (val.disaster_id != null && val.detail_id != null) {
                    this.ii_disaster_type = {
                        system_id: val.disaster_id,
                        system_name: val.disaster_name
                    };
                    this.ii_disaster_detail = {
                        system_id: val.detail_id,
                        system_name: val.detail_name
                    };
                }

                if (val.incident_level != 'null') {
                    this.ii_severity_level = Number(val.incident_level);
                } else {
                    this.ii_severity_level = null;
                }
            }
        },

        displayConfirmationCloseModal(val) {
            if (val == true) {
                this.incidentModal = true;
            }
        },
        // Doe PDF เลือกได้
        columnsSelector(val) {
            if (val.length == 0) {
                this.incident_Table = [];
            } else {
                this.incident_Table = this.cloneTable;
            }
        }

        // check_duplicate(val) {
        //   if (val == "duplicate") {
        //     // this.$toast.add({
        //     //   severity: "error",
        //     //   summary: "เพิ่มข้อมูลชุดเผชิญเหตุไม่สำเร็จ",
        //     //   detail: "มีข้อมูลชุดเผชิญเหตุนี้ในระบบแล้ว",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "error",
        //           title:"เพิ่มข้อมูลชุดเผชิญเหตุไม่สำเร็จ",
        //           text: "มีข้อมูลชุดเผชิญเหตุนี้ในระบบแล้ว",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   } else {
        //     // this.$toast.add({
        //     //   severity: "success",
        //     //   summary: "เพิ่มข้อมูลสำเร็จ",
        //     //   detail: "ข้อมูลชุดเผชิญเหตุ",
        //     //   life: 3000,
        //     // });
        //     this.$fire({
        //           type: "success",
        //           title:"เพิ่มข้อมูลสำเร็จ",
        //           text: "ข้อมูลชุดเผชิญเหตุ",
        //           timer: 3000,
        //           confirmButtonColor: '#28B463',
        //         });
        //   }
        // },
    },
    created() {
        this.$nextTick(() => {
            this.searchInputRef = this.$refs.searchInput?.$el || this.$refs.searchInput;
        });

        // Doe โหลด โทรศัพท์
        // Doe width 2/4
        window.addEventListener('resize', this.handleResize);
        this.handleResize();

        if (this.window.width <= 430) {
            // console.log("this.window.width is",this.window.width)
            // console.log("00000")
            this.searchMenu();
        } else {
            // console.log("this.window.width is",this.window.width)
            // console.log("1111")
            this.ms = true;
            this.initialData();
        }
        // Doe โหลด โทรศัพท์

        // Doe PDF เลือกได้  4/5
        this.columnsSelector = this.columns;
        this.PDF_BodySizeSelect = this.PDF_BodySize;
        this.PDF_BodySizeHorSelect = this.PDF_BodySizeHor;
        // Doe PDF เลือกได้  4/5  จบ

        const decodedToken = this.decodeJWT(localStorage.getItem('token'));
        // this.initialData();
        this.checkRole = decodedToken.permission_id;

        this.checkView_data = decodedToken.view_data;
        this.checkAdd_data = decodedToken.add_data;
        this.checkEdit_data = decodedToken.edit_data;
        this.checkDelete_data = decodedToken.delete_data;

        // console.log(`checkRole = ${this.checkRole} `);
        // console.log(`checkView_data = ${this.checkView_data} `);
        // console.log(`checkAdd_data = ${this.checkAdd_data} `);
        // console.log(`checkEdit_data = ${this.checkEdit_data} `);
        // console.log(`checkDelete_data = ${this.checkDelete_data} `);

        this.Clone_Data_text_Footer = this.setCloneData(this.Data_text_Footer);
    },

    // Doe โหลด โทรศัพท์
    // Doe width 3/4
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    // Doe โหลด โทรศัพท์

    methods: {
        async updateDates() {
            try {
                this.loadingCreate = true;
                const userOrg = this.getUserOrganize();
                const userId = this.getUsername();

                // Format selected records
                const formattedRecords = this.selectedIncidentInfo.map((item) => ({
                    incident_id: item.incident_id,
                    ...item
                }));

                // console.log('formattedRecords', formattedRecords);

                const response = await this.axios.post(`${this.$url_service}/initial/incident?user=${userId}`, {
                    body: {
                        topic: 'edit-incident_date_multiple',
                        selectedIncidentInfo: formattedRecords,
                        userOrg: userOrg
                    }
                });

                // Check if response exists and has data
                if (response && response.data) {
                    if (response.data.success) {
                        this.loadingCreate = false;
                        this.tempFor_displayConfirmationCloseModal = 'add';
                        this.incidentModal = false;

                        await this.$fire({
                            type: 'success',
                            title: 'ปรับปรุงข้อมูล',
                            text: `อัปเดตข้อมูลชุดเผชิญเหตุจำนวน ${response.data.updatedIds?.length || 0} รายการ`,
                            timer: 3000,
                            confirmButtonColor: '#28B463'
                        });

                        // Refresh data after successful update
                        await this.searchIncidentInfo();
                    } else {
                        throw new Error(response.data.message || 'ไม่สามารถอัปเดตข้อมูลได้');
                    }
                }
            } catch (error) {
                this.loadingCreate = false;
                await this.$fire({
                    type: 'error',
                    title: 'เกิดข้อผิดพลาด',
                    text: error.response?.data?.message || error.message || 'ไม่สามารถอัปเดตข้อมูลได้',
                    timer: 3000,
                    confirmButtonColor: '#DC3545'
                });
            } finally {
                this.loadingCreate = false;
            }
        },

        onSelectAll(checked) {
            if (checked) {
                this.selectedIncidentInfo = [...this.incident_Table];
            } else {
                this.selectedIncidentInfo = [];
            }
            this.$emit('selectedIncidentInfo', this.selectedIncidentInfo);
            // console.log('selectedIncidentInfo', this.selectedIncidentInfo);
        },

        onSelectRow(row, checked) {
            if (checked) {
                if (!this.selectedIncidentInfo.some((item) => item.incident_id === row.incident_id)) {
                    this.selectedIncidentInfo.push(row);
                }
            } else {
                this.selectedIncidentInfo = this.selectedIncidentInfo.filter((item) => item.incident_id !== row.incident_id);
            }
            this.$emit('selectedIncidentInfo', this.selectedIncidentInfo);
            // console.log('selectedIncidentInfo', this.selectedIncidentInfo);
        },

        decodeJWT(token) {
            try {
                const payload = token.split('.')[1];
                // Replace Base64URL to Base64
                const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
                // Decode Base64
                const decodedPayload = atob(base64);
                // Handle UTF-8 encoding and return the parsed JSON object
                const jsonPayload = decodeURIComponent(
                    decodedPayload
                        .split('')
                        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
                        .join('')
                );
                return JSON.parse(jsonPayload);
            } catch (error) {
                console.error('Failed to decode JWT token:', error);
                return null;
            }
        },

        saveData_Modal(ModalName) {
            if (ModalName === 'search') {
                if (!this.isFocused('TextBox_2_search') && !this.isFocused('TextBox_3_search')) {
                    this.searchIncidentInfo();
                }
            } else if (ModalName === 'Modal_Main') {
                if (
                    this.deviceDetailModal === false &&
                    !this.isFocused('TextBox_2') &&
                    !this.isFocused('TextBox_3') &&
                    !this.isFocused('TextBox_4')
                ) {
                    this.saveData();
                }
            } else if (ModalName === 'Modal_device') {
                if (!this.isFocused('TextBox_2_device') && !this.isFocused('TextBox_3_device')) {
                    this.addDeviceData();
                }
            }
        },
        exportCSV() {
            debugger;
            this.$refs.dt.exportCSV();
        },

        // Doe โหลด โทรศัพท์
        // Doe width 4/4
        handleResize() {
            this.window.width = window.innerWidth;
            this.window.height = window.innerHeight;

            this.table_BOXmanege = window.innerWidth > 700 ? 'p-field p-col' : '';
            this.table_editBTN = window.innerWidth > 700 ? this.$i18n.t('editBtn') : '';
            this.table_deleteBTN = window.innerWidth > 700 ? this.$i18n.t('deleteBtn') : '';
            if (window.innerWidth > 700) {
                this.table_headerStyle = this.checkInnerWidth('15rem', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('15rem', 'Body');
            } else {
                this.table_headerStyle = this.checkInnerWidth('105px', 'Column');
                this.table_bodyStyle = this.checkInnerWidth('105px', 'Body');
            }
        },

        async searchMenu() {
            // console.log("79")
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
        },

        // Doe โหลด โทรศัพท์

        // Doe ค้นหา  3/6
        search() {
            // Store reference to the input element
            if (event && event.target) {
                this.searchInputRef = event.target;
            }

            // Cancel any existing timeout
            if (this.searchTimeout) {
                clearTimeout(this.searchTimeout);
            }

            // Use debounce to delay processing
            this.searchTimeout = setTimeout(() => {
                if (this.filter != '' && this.incident_Table !== []) {
                    this.incident_Table = this.cloneTable.filter((item) => {
                        // Normalize null values
                        if (item.disaster_name == null || item.disaster_name == 'null') {
                            item.disaster_name = '-';
                        }
                        if (item.detail_name == null || item.detail_name == 'null') {
                            item.detail_name = '-';
                        }

                        return (
                            (this.columns_incident_name ? item.incident_name.includes(this.filter) : '') ||
                            (this.columns_disaster_name ? item.disaster_name.includes(this.filter) : '') ||
                            (this.columns_detail_name ? item.detail_name.includes(this.filter) : '') ||
                            (this.columns_date_create ? item.date_create_ddmmyy.includes(this.filter) : '') ||
                            (this.columns_date_update ? item.date_update_ddmmyy.includes(this.filter) : '')
                        );
                    });

                    // Update indices
                    for (let i = 0; i < this.incident_Table.length; i++) {
                        this.incident_Table[i]['index'] = i + 1;
                    }
                } else {
                    // Create a fresh copy of the cloned data
                    this.incident_Table = [...this.cloneTable];
                    for (let i = 0; i < this.incident_Table.length; i++) {
                        this.incident_Table[i]['index'] = i + 1;
                    }
                }

                // Restore focus to input element after rendering completes
                this.$nextTick(() => {
                    if (this.searchInputRef) {
                        this.searchInputRef.focus();

                        // Place cursor at the end of the text
                        const length = this.searchInputRef.value.length;
                        this.searchInputRef.setSelectionRange(length, length);
                    }
                });
            }, 300); // 300ms delay
        },
        // Doe ค้นหา  3/6 จบ

        async initialData() {
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            this.ms = true;
            this.filter = '';
            this.cloneTable = [];
            this.loading = true;
            await this.axios
                .post(`${this.$url_service}/initial/option`, {
                    body: { group: 'dg-02' }
                })
                .then((response) => {
                    (this.disasterTypeOptions = response.data.data),
                        this.disasterTypeOptions.splice(0, 0, {
                            system_id: 'getall',
                            system_name: this.$i18n.t('selectAll')
                        });
                });
            await this.axios
                .post(`${this.$url_service}/initial/incident`, {
                    body: {
                        topic: 'get-table',
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 3/4
                .then((response) => {
                    this.incident_Table = response.data.data;
                    // Doe ค้นหา  4/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  4/6
                    for (let i = 0; i < this.incident_Table.length; i++) {
                        this.incident_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.incident_Table == id  ",this.incident_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.incident_Table);
                });
            // Doe : เพิ่ม ลำดับ 3/4 จบ

            if (this.columns_disabled == true) {
                this.incident_Table = this.cloneTable;
            } else {
                this.incident_Table = [];
            }

            this.loading = false;
        },
        formatData(data) {
            for (let index = 0; index < data.length; index++) {
                if (data[index].disaster_name == null || data[index].disaster_name == 'null' || data[index].disaster_name == '') {
                    data[index].disaster_name = '-';
                }
                if (data[index].detail_name == null || data[index].detail_name == 'null' || data[index].detail_name == '') {
                    data[index].detail_name = '-';
                }

                if (data[index].date_create_ddmmyy == null || data[index].date_create_ddmmyy == 'null' || data[index].date_create_ddmmyy == '') {
                    data[index].date_create_ddmmyy = '-';
                } else {
                    data[index].date_create_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_create_ddmmyy));
                }

                if (data[index].date_update_ddmmyy == null || data[index].date_update_ddmmyy == 'null' || data[index].date_update_ddmmyy == '') {
                    data[index].date_update_ddmmyy = '-';
                } else {
                    data[index].date_update_ddmmyy = this.changeDateToThai(this.checkDate(data[index].date_update_ddmmyy));
                }
            }
        },
        someHandler() {
            this.ii_disaster_detail = null;
        },

        closeAllModal() {
            // console.log("Close and don`t save data");
            this.incidentModal = false;
            this.displayConfirmationCloseModal = false;
            this.clearData();
        },

        async confirmDelete() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userOrg = this.getUserOrganize(); //เช็คสิทธิ์
            const userId = this.getUsername();

            if (this.deleteAt == 'detail-table') {
                this.deviceDetail_table = this.deviceDetail_table.filter((val) => val !== this.deviceDetailDelete);
                this.displayConfirmation = false;
            } else {
                await this.axios
                    .post(`${this.$url_service}/initial/incident?user=${userId}`, {
                        body: {
                            topic: 'delete-incident',
                            id: this.temp
                        }
                    })
                    .then(() =>
                        // this.initialData()
                        this.searchIncidentInfo()
                    );
                this.displayConfirmation = false;
                // console.log("this.deviceDetailDelete",this.deviceDetailDelete)
                // this.$toast.add({
                //   severity: "success",
                //   summary: "ลบข้อมูลสำเร็จ",
                //   detail: "ข้อมูลชุดเผชิญเหตุ",
                //   life: 3000,
                // });
                this.$fire({
                    type: 'success',
                    title: 'ลบข้อมูลสำเร็จ',
                    text: 'ข้อมูลชุดเผชิญเหตุ',
                    timer: 3000,
                    confirmButtonColor: '#28B463'
                });
            }
        },

        async searchIncidentInfo() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userId = this.getUsername();

            this.ms = true;
            // this.filter='';
            this.cloneTable = [];
            this.loading = true;
            const userOrg = this.checkPermission() ? null : this.getUserOrganize(); //เช็คสิทธิ์
            await this.axios
                .post(`${this.$url_service}/initial/incident`, {
                    body: {
                        topic: 'search-table',
                        name: this.incident_name,
                        type: this.disasterTypeSelect,
                        detail: this.disasterDetailSelect,
                        userOrg
                    }
                })
                // Doe : เพิ่ม ลำดับ 4/4
                .then((response) => {
                    this.incident_Table = response.data.data;
                    // Doe ค้นหา  5/6
                    this.cloneTable = response.data.data;
                    // Doe ค้นหา  5/6
                    for (let i = 0; i < this.incident_Table.length; i++) {
                        this.incident_Table[i]['index'] = i + 1;
                    }
                    // console.log("this.incident_Table == id  ",this.incident_Table)

                    // Doe ช่องว่างใส่ ขีด
                    this.formatData(this.incident_Table);

                    // this.search()

                    this.setSearchText_Footer();
                });
            // Doe : เพิ่ม ลำดับ 4/4 จบ

            if (this.columns_disabled == true) {
                this.incident_Table = this.cloneTable;
            } else {
                this.incident_Table = [];
            }

            this.search();
            this.loading = false;
        },
        setSearchText_Footer() {
            this.text_Footer = false;
            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            if (this.incident_name !== '' || this.disasterTypeSelect !== null || this.disasterDetailSelect !== null) {
                for (let index = 0; index < this.Data_text_Footer.length; index++) {
                    const element = this.Data_text_Footer[index];

                    if (element.DataName === 'ชื่อชุดเผชิญเหตุ' && this.incident_name !== '') {
                        element.textShow = this.incident_name;
                    }
                    if (element.DataName === 'ประเภทสาธารณภัย' && this.disasterTypeSelect !== null) {
                        element.textShow = this.disasterTypeSelect.system_name;
                    }
                    if (element.DataName === 'ลักษณะที่เกิดเหตุ' && this.disasterDetailSelect !== null) {
                        element.textShow = this.disasterDetailSelect.system_name;
                    }
                }
                this.text_Footer = true;
            }
        },
        async saveData() {
            if (!this.checkToken()) {
                return;
            }

            // console.log('this.checkToken() = ', this.checkToken());

            const userId = this.getUsername();

            //Check null value
            if (this.ii_incident_name == '') {
                this.error_ii_incident_name = true;
            } else {
                if (this.selectedData == '') {
                    // โหลดเพิ่มแก้ไข 4/8
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 4/8 จบ

                    const userOrg = this.getUserOrganize(); //เช็คสิทธิ์

                    await this.axios
                        .post(`${this.$url_service}/initial/incident?user=${userId}`, {
                            body: {
                                topic: 'add-incident',
                                userOrg,
                                name: this.ii_incident_name,
                                level: this.ii_severity_level,
                                disaster_type: this.ii_disaster_type,
                                disaster_detail: this.ii_disaster_detail,
                                table: this.deviceDetail_table
                            }
                        })
                        .then((response) => {
                            (this.check_duplicate = response.data.message),
                                // this.initialData();
                                this.searchIncidentInfo();

                            // โหลดเพิ่มแก้ไข 5/8
                            this.loadingCreate = false;
                            // โหลดเพิ่มแก้ไข 5/8 จบ
                            // เพิ่ม เพิ่มข้อมูลให้แสดงรอบสอง พร้อมกับ เช็คข้อมูลซ้ำ
                            // console.log("this.check_duplicate ",this.check_duplicate)
                            if (this.check_duplicate == 'duplicate') {
                                this.$fire({
                                    type: 'error',
                                    title: 'เพิ่มข้อมูลพื้นฐานระบบไม่สำเร็จ',
                                    text: 'มีข้อมูลนี้ในระบบแล้ว',
                                    timer: 3000,
                                    confirmButtonColor: '#d33'
                                });
                            } else {
                                this.$fire({
                                    title: 'เพิ่มข้อมูลสำเร็จ',
                                    text: 'ข้อมูลชุดเผชิญเหตุ',
                                    type: 'success',
                                    timer: 3000,
                                    confirmButtonColor: '#28B463'
                                });
                            }
                        });
                    this.tempFor_displayConfirmationCloseModal = 'add';
                    this.incidentModal = false;
                } else {
                    // โหลดเพิ่มแก้ไข 6/8 จบ
                    this.loadingCreate = true;
                    // โหลดเพิ่มแก้ไข 6/8 จบ

                    const userId = this.getUsername();
                    await this.axios
                        .post(`${this.$url_service}/initial/incident?user=${userId}`, {
                            body: {
                                topic: 'edit-incident',
                                id: this.temp,
                                name: this.ii_incident_name,
                                level: this.ii_severity_level,
                                disaster_type: this.ii_disaster_type,
                                disaster_detail: this.ii_disaster_detail,
                                table: this.deviceDetail_table
                            }
                        })
                        .then(() =>
                            // this.initialData()
                            this.searchIncidentInfo()
                        );
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    this.loadingCreate = false;
                    // โหลดเพิ่มแก้ไข 7/8 จบ
                    // this.$toast.add({
                    //   severity: "success",
                    //   summary: "แก้ไขข้อมูลสำเร็จ",
                    //   detail: `ข้อมูลชุดเผชิญเหตุ`,
                    //   life: 3000,
                    // });
                    this.$fire({
                        type: 'success',
                        title: 'แก้ไขข้อมูลสำเร็จ',
                        text: `ข้อมูลชุดเผชิญเหตุ`,
                        timer: 3000,
                        confirmButtonColor: '#28B463'
                    });
                    this.incidentModal = false;
                }
            }
        },

        addDeviceData() {
            if (this.ii_device_type == null) {
                this.error_ii_device_type = true;
            } else {
                this.deviceDetailModal = false;
                this.deviceDetail_table.push({
                    device_type: this.ii_device_type.system_name,
                    amount: this.ii_device_amount,
                    unit: this.ii_device_unit
                });
            }
        },

        async editData(data) {
            if (!this.checkToken()) {
                return;
            }

            function toThaiDateFormat(dateString) {
                try {
                    // Split the date string by '/'
                    const [day, month, year] = dateString.split('/');

                    // Create a date object (months in JavaScript are 0-based, so subtract 1 from month)
                    const date = new Date(year, month - 1, day);

                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        return '-';
                    }

                    // Format options
                    const options = {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric'
                    };

                    // Convert to Thai date
                    return date.toLocaleDateString('th-TH', options);
                } catch (error) {
                    return '-';
                }
            }

            // console.log('this.checkToken() = ', this.checkToken());

            this.header = this.$i18n.t('ii_modal_title_edit');
            await this.axios
                .post(`${this.$url_service}/initial/incident`, {
                    body: {
                        topic: 'showone-incident',
                        id: data
                    }
                })
                .then((response) => {
                    (this.selectedData = response.data.data),
                        (this.ii_incident_name = response.data.data.incident_name),
                        (this.deviceDetail_table = JSON.parse(response.data.data.incident_equipment_table));

                    this.date_create_form =
                        toThaiDateFormat(response.data.data.date_create_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_create_ddmmyy);
                    this.date_update_form =
                        toThaiDateFormat(response.data.data.date_update_ddmmyy) == null
                            ? '-'
                            : toThaiDateFormat(response.data.data.date_update_ddmmyy);
                });
        },

        clearData() {
            this.dropdownClearFilerValue += 1;
            //Edit data
            if (this.selectedData != '') {
                this.header = this.$i18n.t('ii_modal_title_add');
                this.temp = null;
                this.displayConfirmation = false;
                this.incidentModal = false;
                this.selectedData = '';
                this.setDefault();

                //Add data
            } else {
                this.temp = null;
                this.displayConfirmation = false;
                this.setDefault();
            }
        },

        setDefault() {
            this.tempFor_displayConfirmationCloseModal = '';
            this.ii_incident_name = '';
            this.ii_severity_level = null;
            this.ii_disaster_type = null;
            this.deviceDetail_table = [];
            this.error_ii_incident_name = false;

            this.date_create_form = '';
            this.date_update_form = '';
        },

        setDefaultDetail() {
            this.dropdownClearFilerValue += 1;
            this.ii_device_type = null;
            this.ii_device_amount = 0;
            this.error_ii_device_type = false;
        },

        async clearSearchField() {
            this.incident_name = '';
            this.disasterTypeSelect = null;
            this.disasterDetailSelect = null;

            this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
            this.text_Footer = false;

            this.dropdownClearFilerValue += 1;
            // Doe ค้นหา
            this.filter = '';
            this.cloneTable = [];
            this.initialData();
        },

        // Doe โหลด โทรศัพท์
        async MobileClearSearchField() {
            // console.log("this.ms3333",this.ms)
            if (this.ms == true) {
                this.clearSearchField();
            } else {
                // console.log("25")
                this.incident_name = '';
                this.disasterTypeSelect = null;
                this.disasterDetailSelect = null;

                this.Data_text_Footer = this.setCloneData(this.Clone_Data_text_Footer);
                this.text_Footer = false;

                this.dropdownClearFilerValue += 1;
                this.filter = '';
                this.cloneTable = [];
            }
        },
        // Doe โหลด โทรศัพท์

        alertDisplay(temp, deleteAt) {
            this.$fire({
                title: 'ยืนยันการลบข้อมูล',
                text: 'คุณต้องการลบข้อมูลนี้ใช่หรือไม่ ?',

                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ตกลง',
                cancelButtonText: 'ยกเลิก'
            }).then((result) => {
                // console.log(temp)
                if (result.value) {
                    // console.log("temp",temp)
                    this.confirmDelete(temp, deleteAt);
                }
            });
        },
        // Doe PDF เลือกได้  5/5
        EditPDF() {
            this.displayEditPDF = true;
            this.columnsSelectorDialog = this.columnsSelector;
        },
        SaveEditPDF() {
            if (this.columnsSelectorDialog.length == 1) {
                this.PDF_minCellWidthVer = 120;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;
                this.PDF_BodySizeSelect = {};

                this.PDF_minCellWidthHor = 120;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;
                this.PDF_BodySizeHorSelect = {};
            } else if (this.columnsSelectorDialog.length <= 4) {
                this.PDF_minCellWidthVer = 70;
                this.PDF_FontHeaderVer = 15;
                this.PDF_FontBodyVer = 12;

                this.PDF_BodySizeSelect = {
                    index: { cellWidth: 35 }
                };

                this.PDF_minCellWidthHor = 70;
                this.PDF_FontHeaderHor = 15;
                this.PDF_FontBodyHor = 12;

                this.PDF_BodySizeHorSelect = {
                    index: { cellWidth: 35 }
                };
            }

            if (this.columnsSelectorDialog.length == 0) {
                this.columns_index = false;
                this.columns_incident_name = false;
                this.columns_disaster_name = false;
                this.columns_detail_name = false;

                this.columns_date_create = false;
                this.columns_date_update = false;

                this.columns_disabled = false;
            } else {
                this.columns_disabled = true;
                // console.log('this.columnsSelectorDialog =', this.columnsSelectorDialog);

                let getData = [];

                // ! จัดข้อมูล
                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    getData.push(this.columnsSelectorDialog[index].dataKey);
                }
                // console.log("getData",getData);

                // ! เช็คข้อมูล

                for (let index = 0; index < this.columnsSelectorDialog.length; index++) {
                    const element = this.columnsSelectorDialog[index].dataKey;

                    if (element == 'index') {
                        this.columns_index = true;
                    } else if (!getData.includes('index')) {
                        // console.log("getData.includes(index)",getData.includes("index"))
                        this.columns_index = false;
                    }

                    if (element == 'incident_name') {
                        this.columns_incident_name = true;
                    } else if (!getData.includes('incident_name')) {
                        this.columns_incident_name = false;
                    }

                    if (element == 'disaster_name') {
                        this.columns_disaster_name = true;
                    } else if (!getData.includes('disaster_name')) {
                        this.columns_disaster_name = false;
                    }

                    if (element == 'detail_name') {
                        this.columns_detail_name = true;
                    } else if (!getData.includes('detail_name')) {
                        this.columns_detail_name = false;
                    }

                    if (element == 'date_create_ddmmyy') {
                        this.columns_date_create = true;
                    } else if (!getData.includes('date_create_ddmmyy')) {
                        this.columns_date_create = false;
                    }

                    if (element == 'date_update_ddmmyy') {
                        this.columns_date_update = true;
                    } else if (!getData.includes('date_update_ddmmyy')) {
                        this.columns_date_update = false;
                    }
                }
            }

            this.columnsSelector = this.columnsSelectorDialog;
            this.displayEditPDF = false;
            this.filter = '';
        },
        CloseEditPDF() {
            this.displayEditPDF = false;
        },
        ClearEditPDF() {
            this.columnsSelectorDialog = [];
        },
        SelectAllEditPDF() {
            this.columnsSelectorDialog = this.columns;
        }
        // Doe PDF เลือกได้  5/5 จบ
    }
};
</script>

<style scoped>
.table_row {
    text-align: center;
}

.p-field {
    margin-bottom: 0rem;
}
</style>

<style>
@keyframes p-progress-spinner-color {
    100%,
    0% {
        stroke: #75e9f4;
    }
    40% {
        stroke: #0057e7;
    }
    66% {
        stroke: #75e9f4;
    }
    80%,
    90% {
        stroke: #0057e7;
    }
}
@media screen and (min-width: 819px) and (max-width: 1200px) {
    #Search {
        width: 20rem;
    }
}
/* @media screen and (min-width: 538px){
      #Create{
      width: 146px;
    }
   
} */
#text_Foote {
    font-size: 1.2rem;
}
#Create {
    width: 149px;
}
#EX {
    width: 149px;
}
#PDF {
    width: 149px;
}
#TABLE_EDIT {
    width: 149px;
}

@media screen and (max-width: 818px) {
    #Search {
        width: 100%;
    }
}

@media screen and (max-width: 430px) {
    #Create {
        width: 50%;
    }
    #EX {
        width: 50%;
    }
    #PDF {
        width: 55%;
    }
    #TABLE_EDIT {
        width: 45%;
    }
    .EV_disasterOptions {
        width: 16.75rem;
        overflow-y: scroll;
    }
    .EV_disasterOptions::-webkit-scrollbar {
        width: 0;
        height: 1px;
    }

    .EV_disasterOptions::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
    }

    .EV_disasterOptions::-webkit-scrollbar-thumb {
        -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.2);
    }
}

.p-datatable-thead {
    border: 2px solid #d6d6d6;
}

.p-datatable-tbody {
    border: 2px solid #d6d6d6;
}
</style>

<style scoped lang="scss">
:deep(.p-datatable-wrapper table) {
    border-left: 1px solid #d6d4d4;
    border-right: 1px solid #d6d4d4;
    border-collapse: separate;
    border-spacing: 0;
}
:deep(.p-datatable-scrollable-header-table) {
    background-color: #d6d4d4;
}
:deep(.p-datatable-wrapper) {
    max-height: 550px;
    overflow: auto;
}

// :deep(.p-dialog) {
//   @media screen and (max-width: 991px) {
//     .p-dialog-content{
//       overflow-y: auto;
//     }
//   }

// }

.p-multiselect {
    min-width: 15rem;
}

.multiselect-custom {
    // Doe PDF เลือกได้
    width: 100%;
    .p-multiselect-label:not(.p-placeholder) {
        padding-top: 0.25rem;
        padding-bottom: 0.25rem;
    }

    .item {
        display: flex;
        align-items: center;
    }

    .item-value {
        padding-left: 10px;
        padding-right: 10px;
        border-radius: 3px;
        display: inline-flex;
        margin-right: 0.5rem;
        background-color: var(--primary-color);
        color: var(--primary-color-text);
    }
}
</style>
